var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBronze2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 635,
    viewBox: "0 0 550 635",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.600098 475.7V158.7L275.1 0.199951L549.6 158.7V475.7L275.1 634.2L0.600098 475.7Z",
    fill: "#E06A36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M275.1 634.2L549.6 475.7L500.6 447.4L295.1 566.1C282.7 573.2 275.1 586.4 275.1 600.7V634.2Z",
    fill: "#9F3A22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.600098 475.7L275.1 634.2V600.7C275.1 586.4 267.5 573.2 255.1 566.1L69.5001 459C57.1001 451.9 41.9001 451.9 29.6001 459L0.600098 475.7Z",
    fill: "#E0A33F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M275.1 33.7V0.199951L0.600098 158.7L29.6001 175.5C42.0001 182.6 57.2001 182.6 69.5001 175.5L255.1 68.4C267.5 61.2 275.1 48 275.1 33.7Z",
    fill: "#EDD6BC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M549.6 475.7V158.7L520.6 175.5C508.2 182.6 500.6 195.8 500.6 210.1V447.4L549.6 475.7Z",
    fill: "#9F3A22"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M275.1 11.8L539.6 164.5V469.9L275.1 622.6L10.6001 469.9V164.5L275.1 11.8ZM275.1 0.199951L0.600098 158.7V475.7L275.1 634.2L549.6 475.7V158.7L275.1 0.199951Z",
    fill: "#E06A36"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M451.9 197.4L324.3 123.7C309.4 115.1 292.4 110.5 275.2 110.5C258 110.5 241 115.1 226.1 123.7L98.5002 197.4C88.5002 203.2 82.3003 213.9 82.3003 225.4V296.9C82.3003 322.5 92.8002 347 111.1 364.7V369.9C111.1 406.4 130.7 440.4 162.2 458.6L275.2 523.9L388.2 458.6C420.6 439.9 438.7 406.6 439.3 364.7C457.7 346.9 468.1 322.5 468.1 296.9V225.4C468.1 213.9 461.9 203.1 451.9 197.4Z",
    fill: "#1C1128"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M275.1 323.2L120.1 236V296.9C120.1 317 130.8 335.6 148.2 345.6L148.9 346V370C148.9 393.1 161.1 414.3 181 425.8L275 480.1L369 425.8C388.9 414.3 401.1 393.1 401.1 362.8V346L401.8 345.6C419.2 335.5 429.9 317 429.9 296.9V236L275.1 323.2Z",
    fill: "#E06A36"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M275.1 323.2V480L369.1 425.7C389 414.2 401.2 393 401.2 362.7V346L401.9 345.6C419.3 335.5 430 317 430 296.9V236L275.1 323.2Z",
    fill: "#9F3A22"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M420.1 253.1V296.9C420.1 313.4 411.2 328.7 397 337L396.3 337.4L391.3 340.3V346.1V362.8C391.3 388.1 381.9 406.9 364.2 417.1L275.2 468.5L186.2 417.1C169.5 407.5 159.1 389.4 159.1 370V346V340.2L154.1 337.3L153.4 336.9C139.1 328.7 130.3 313.3 130.3 296.8V253L270.4 331.8L275.3 334.6L280.2 331.8L420.1 253.1ZM430.1 236L275.1 323.2L120.1 236V296.9C120.1 317 130.8 335.6 148.2 345.6L148.9 346V370C148.9 393.1 161.1 414.3 181 425.8L275 480.1L369 425.8C388.9 414.3 401.1 393.1 401.1 362.8V346L401.8 345.6C419.2 335.5 429.9 317 429.9 296.9V236H430.1Z",
    fill: "#E06A36"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M159 340.2L275.1 405.6V417.1L159 351.7V340.2Z",
    fill: "#9F3A22"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M391.2 340.2L275.1 405.6V417.1L391.2 351.7V340.2Z",
    fill: "#E06A36"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143.6 215.1L275.1 291L406.6 215.1L305.2 156.6C286.5 145.8 263.6 145.8 244.9 156.6L143.6 215.1Z",
    fill: "#698445"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M305.3 156.6C296 151.2 285.6 148.5 275.2 148.5V291.1L406.7 215.2L305.3 156.6Z",
    fill: "#1F4927"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M275.1 236L148.9 218.2L275.1 291.1L401.3 218.2L275.1 236Z",
    fill: "#143321"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M275.1 158.5C283.9 158.5 292.6 160.8 300.2 165.2L386.6 215.1L275.1 279.5L163.6 215.1L250 165.2C257.6 160.9 266.3 158.5 275.1 158.5ZM275.1 148.5C264.7 148.5 254.3 151.2 245 156.6L143.6 215.1L275.1 291L406.6 215.1L305.2 156.6C295.9 151.2 285.5 148.5 275.1 148.5Z",
    fill: "#2B5E36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronze2);
export default __webpack_public_path__ + "static/media/bronze-2.ca1b9f3828159e0d2c14f42e5c336ec2.svg";
export { ForwardRef as ReactComponent };